export function recordLabel(w: number, l: number, t = 0): string {
  return t > 0 ? `${w}-${l}-${t}` : `${w}-${l}`;
}

/** ".700" — the conventional baseball-style win percentage. */
export function pctLabel(v: number | null | undefined): string {
  if (v == null || Number.isNaN(v)) return "—";
  const s = v.toFixed(3);
  return v < 1 ? s.replace(/^0/, "") : s;
}

export function signed(n: number): string {
  return n > 0 ? `+${n}` : String(n);
}

export function formatDate(
  value: Date | string | null | undefined,
  opts: Intl.DateTimeFormatOptions = { dateStyle: "medium" },
): string {
  if (!value) return "—";
  const d = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(d.getTime())) return "—";
  return new Intl.DateTimeFormat("en-US", opts).format(d);
}

export function formatDateTime(value: Date | string | null | undefined): string {
  return formatDate(value, { dateStyle: "medium", timeStyle: "short" });
}

/** "Week 6" / "Match #8" / "Round 3" — whatever identifies a game. */
export function gameSlot(game: {
  stage: string;
  weekNumber?: number | null;
  weekLabel?: string | null;
  bracketLabel?: string | null;
}): string {
  if (game.bracketLabel) return game.bracketLabel;
  if (game.weekLabel) return game.weekLabel;
  if (game.weekNumber != null) return `Week ${game.weekNumber}`;
  return game.stage === "playoff" ? "Playoffs" : "—";
}

// Defined in the shared package so the server's season-split labels and the
// web's game-log labels cannot drift apart; re-exported here for convenience.
export { STAGE_LABEL } from "@mpl/shared";

/**
 * How an article tag reads on screen. Tags are stored as slugs ("the-beat",
 * "season-2") so they stay stable in URLs; people read "The Beat" and
 * "Season 2".
 */
const TAG_LABELS: Record<string, string> = {
  "the-beat": "The Beat",
  "picks-and-bans": "Picks & bans",
};
export function tagLabel(tag: string): string {
  if (TAG_LABELS[tag]) return TAG_LABELS[tag];
  const words = tag.replace(/-/g, " ");
  return words.charAt(0).toUpperCase() + words.slice(1);
}

/** Competition tags lead the filter row; categories follow, biggest first. */
export const COMPETITION_TAGS = new Set(["season-1", "season-2", "season-3", "playoffs"]);
